import PageTypeB from "../components/pageTypeB/PageTypeB";
import { pagesDataB } from "../data/pagesData";

const Page5 = () => {
  return (
    <PageTypeB
      title={pagesDataB[1].title}
      paragraph1={pagesDataB[1].paragraph1}
      paragraph2={pagesDataB[1].paragraph2}
      paragraph3={pagesDataB[1].paragraph3}
    />
  );
};

export default Page5;
